<template>
  <section class="lead-assign-manager" aria-label="Assign lead manager">
    <app-button v-if="!open" design="new" @click.native="show">Assign manager</app-button>
    <form v-else @submit.prevent="assign">
      <app-form-group label="Assign manager" required>
        <app-select
          v-model="managerId"
          design="new"
          :options="managers"
          :reduce="manager => manager.id"
          :loading="loading"
          :disabled="loading || saving"
          placeholder="Select a manager"
          aria-label="Assign manager"
        />
      </app-form-group>
      <p>The current stage stays unchanged. No automatic WhatsApp or email initial contact will be sent.</p>
      <p v-if="!loading && !error && !managers.length">No eligible managers for this lead.</p>
      <p v-if="error" role="alert">{{ error }}</p>
      <app-cells :indent="false">
        <app-button design="new" type="submit" :disabled="!managerId || loading || saving">{{ saving ? 'Assigning…' : 'Assign' }}</app-button>
        <app-button design="new" theme="dark" :disabled="saving" @click.native="open = false">Cancel</app-button>
        <app-button v-if="error" design="new" theme="dark" :disabled="saving" @click.native="show">Retry</app-button>
      </app-cells>
    </form>
  </section>
</template>

<script>
import { getLeadFlowAssignmentManagers, postLeadFlowAssignManager } from '@/http'

export default {
  name: 'LeadAssignManager',
  props: { leadId: { type: Number, required: true } },
  data() {
    return { open: false, loading: false, saving: false, managerId: null, managers: [], error: '' }
  },
  methods: {
    async show() {
      this.open = true
      this.loading = true
      this.error = ''
      this.managerId = null
      try {
        const { data } = await getLeadFlowAssignmentManagers(this.leadId)
        if (!this._isDestroyed) this.managers = data.results || []
      } catch (error) {
        if (!this._isDestroyed) this.error = error.message
      } finally {
        this.loading = false
      }
    },
    async assign() {
      if (!this.managerId || this.saving || this.loading) return
      this.saving = true
      this.error = ''
      this.$emit('pending-change', true)
      try {
        await postLeadFlowAssignManager(this.leadId, this.managerId)
        if (this._isDestroyed) return
        this.open = false
        this.$notify({ type: 'success', title: 'Manager assigned' })
        this.$emit('assigned')
      } catch (error) {
        if (!this._isDestroyed) this.error = error.message
      } finally {
        this.saving = false
        this.$emit('pending-change', false)
      }
    }
  }
}
</script>

<style scoped>
.lead-assign-manager { margin: 12px 24px; }
.lead-assign-manager form { max-width: 560px; padding: 16px; border: 1px solid #dfe4dd; border-radius: 8px; background: #fff; }
.lead-assign-manager p { margin: 0 0 12px; font-size: 13px; }
.lead-assign-manager [role="alert"] { color: #b85049; }
</style>
